import api from './api';

const MeetingService = {
  async book(meetingData) {
    const { data } = await api.post('/meetings', meetingData);
    return data.data;
  },

  async list(params = {}) {
    const { data } = await api.get('/meetings/mine', { params });
    return { data: data.data, meta: data.meta };
  },

  async getOne(id) {
    const { data } = await api.get(`/meetings/${id}`);
    return data.data;
  },

  async cancel(id) {
    const { data } = await api.post(`/meetings/${id}/cancel`);
    return data.data;
  },
};

export default MeetingService;
